import { mapAtom } from '../../../atoms/map/map'
import { findLayer } from '../../utils/findLayer'

export function changeVoiceEventLayerVisibility(visible: boolean) {
  const map = mapAtom.map
  const layer = findLayer(map, 'voiceEvents')
  layer.setVisible(visible)
}
